export const dict = {
  en: {
    dir: "ltr",
    nav: {
      features: "Why itminane",
      how: "How it works",
      hardware: "Hardware",
      ai: "Pulse AI",
      faq: "FAQ",
      quote: "Request a quote",
      whatsapp: "WhatsApp us",
      admin: "Admin",
      menu: "Menu",
    },
    hero: {
      badge: "itminane · اطمئنان — for Arabic & English schools",
      h1a: "They tap.",
      h1b: "You know.",
      sub: "itminane is the school-gate attendance system that sends parents a WhatsApp message the instant their child walks through the gate. No roll call. No teacher effort. Just quiet reassurance.",
      ctaQuote: "Request a school quote",
      ctaWhats: "Order on WhatsApp",
      b1: "Instant WhatsApp alert",
      b2: "Zero teacher effort",
      b3: "Weatherproof terminal",
      floatTitle: "itminane",
      floatMsg: "Sara entered school · Gate A, 8:02 AM",
      floatTime: "now",
      imgAlt: "White itminane attendance terminal mounted on a wall",
    },
    marquee: [
      "اطمئنان",
      "peace of mind",
      "tap & go",
      "zero roll call",
      "instant WhatsApp",
      "every parent, every day",
    ],
    bento: {
      kicker: "Who it's for",
      title: "Three wins, every morning.",
      parents: {
        tag: "For parents",
        title: "The gate says good morning.",
        body: "A WhatsApp message lands the second your child taps in — arrival and departure, every single day. No asking, no wondering.",
        imgAlt: "An itminane tap card held up to the glowing reader ring on the terminal",
      },
      teachers: {
        tag: "For teachers",
        title: "Roll call? Cancelled.",
        body: "No lists, no head-counting, no paperwork. The gate takes the register by itself while class starts on time.",
      },
      admin: {
        tag: "For schools",
        title: "Every arrival, on the record.",
        body: "Automated daily logs, gate-level security and clean attendance reports — ready when you need them.",
      },
    },
    sim: {
      kicker: "Live demo",
      title: "Try the morning gate",
      sub: "Tap the card and watch what a parent receives — in under a second.",
      arrival: "Morning arrival",
      departure: "Home time",
      tapBtn: "Tap the card",
      tapAgain: "Tap again",
      tapping: "Reading…",
      terminal: "itminane terminal",
      screenIdle: "Ready to tap",
      screenRead: "Reading card…",
      screenDone: "Recorded",
      hint: "This is a simulation — the real notification arrives on the parent's WhatsApp.",
      notif: {
        chat: "itminane",
        online: "online",
        arrive: "Sara Ahmed arrived at school",
        depart: "Sara Ahmed left school",
        meta: "Gate A",
        timeA: "8:02 AM",
        timeD: "2:30 PM",
      },
      empty: "The parent's notification will appear here",
    },
    how: {
      kicker: "How it works",
      title: "Three steps. Zero effort.",
      steps: [
        {
          n: "01",
          t: "Tap & go",
          b: "A child taps their card on the terminal at the gate. The read takes a fraction of a second — no queue, no camera, no fingerprint.",
        },
        {
          n: "02",
          t: "Secure relay",
          b: "The terminal sends an encrypted attendance event to the itminane cloud over the school's Wi-Fi or a 4G SIM.",
        },
        {
          n: "03",
          t: "WhatsApp lands",
          b: "Parents receive the notification instantly, with the child's name, gate and time. Teachers never touch a thing.",
        },
      ],
      note: "Teacher effort required: none.",
    },
    hw: {
      kicker: "The hardware",
      title: "Tough at the gate. Simple in the hand.",
      sub: "Two pieces — one terminal at each entrance, one card for every student. That's the whole system.",
      terminal: {
        name: "itminane Terminal",
        sub: "Mounted at every school gate",
        feats: [
          "Wall or gate mount",
          "Works on school Wi-Fi or a 4G SIM",
          "Battery backup for power cuts",
          "Loud confirmation chime",
          "Weather-resistant enclosure",
        ],
      },
      card: {
        name: "itminane Card",
        sub: "One per student, lanyard-ready",
        feats: [
          "Durable student card on a lanyard",
          "Printed with your school's identity",
          "Instantly re-issued if lost",
          "One tap — no camera, no fingerprint",
        ],
        imgAlt: "Three itminane tap cards on purple and orange lanyards",
      },
      note: "Final specifications are confirmed together with your quote.",
    },
    ai: {
      badge: "Coming soon",
      kicker: "itminane Pulse",
      title: "Soon: AI that helps you understand your child.",
      body: "Pulse will read arrival patterns and gently surface what matters — a child late three mornings in a row, a weekly attendance digest for parents, and insights that help schools care earlier.",
      chips: ["Arrival patterns", "Gentle anomaly alerts", "Weekly parent digest"],
    },
    quote: {
      kicker: "Get started",
      title: "Request a quote",
      sub: "Tell us about your school and we'll reply on WhatsApp with a tailored offer — hardware, cards and setup included.",
      name: "Full name",
      school: "School name",
      city: "City / Country",
      students: "Number of students",
      phone: "WhatsApp number",
      role: "Your role",
      message: "Anything else? (optional)",
      msgPlaceholder: "Number of gates, questions, timelines…",
      namePh: "e.g. Amina Khalil",
      schoolPh: "e.g. Al-Noor International School",
      cityPh: "e.g. Dubai, UAE",
      roles: {
        principal: "Principal / Administrator",
        it: "IT Coordinator",
        teacher: "Teacher",
        parent: "Parent",
        other: "Other",
      },
      submit: "Send request",
      sending: "Sending…",
      successTitle: "Request received.",
      successBody: "We'll message you on WhatsApp shortly — usually the same day.",
      successAgain: "Send another request",
      err: "Something went wrong — please check the fields and try again.",
      waTitle: "Prefer to chat?",
      waBody: "Message us directly and we'll take your order right inside WhatsApp.",
      waBtn: "Order on WhatsApp",
      contact: "Reach us",
      rights: "All rights reserved.",
    },
    faq: {
      kicker: "Questions",
      title: "Good questions, honest answers",
      items: [
        {
          q: "Do we need fast internet at the gate?",
          a: "No. The terminal works on your school's Wi-Fi or a 4G SIM — whichever is available. Attendance notifications are tiny, so even a modest connection is enough.",
        },
        {
          q: "Who installs it?",
          a: "We ship the terminal ready to mount. Most schools hang it by the gate and power it on — we walk your team through pairing the cards on a short call.",
        },
        {
          q: "What if a child loses a card?",
          a: "Cards are inexpensive and re-issued instantly. Deactivate the lost card from your dashboard and tap the new one once — done.",
        },
        {
          q: "Can both parents get notifications?",
          a: "Yes. Mother, father or a guardian — any WhatsApp number can be linked to the same child, and each receives the same alert.",
        },
        {
          q: "Is our children's data private?",
          a: "The system stores only what it needs: a card ID, a name and a parent's number. Attendance records belong to the school and are never sold or shared.",
        },
      ],
    },
    gallery: {
      kicker: "Gallery",
      title: "Inside the system",
      sub: "The terminal, the card, and the moment a parent finds out.",
      captions: [
        "At the gate, ready every morning",
        "One card per student",
        "Early mornings and late afternoons",
        "The message that matters",
      ],
    },
    footer: {
      story: "itminane — from the Arabic اطمئنان: the peace of mind you feel when you know they made it.",
      product: "Product",
      company: "Company",
      contact: "Contact",
      admin: "Admin",
      rights: "All rights reserved.",
      bilingual: "English · العربية",
    },
    admin: {
      loginTitle: "Admin sign in",
      loginSub: "Quote requests dashboard",
      email: "Email",
      password: "Password",
      signIn: "Sign in",
      signingIn: "Signing in…",
      back: "Back to site",
      dashTitle: "Quote requests",
      new: "new",
      total: "requests",
      loading: "Loading…",
      empty: "No requests yet — they'll appear here the moment a school submits the form.",
      error: "Couldn't load requests. Try refreshing.",
      signOut: "Sign out",
      viewSite: "View site",
      msgLabel: "Message",
      retry: "Retry",
    },
  },
  ar: {
    dir: "rtl",
    nav: {
      features: "لماذا اطمئنان",
      how: "كيف يعمل",
      hardware: "العتاد",
      ai: "Pulse AI",
      faq: "الأسئلة",
      quote: "اطلب عرض سعر",
      whatsapp: "راسلنا واتساب",
      admin: "الإدارة",
      menu: "القائمة",
    },
    hero: {
      badge: "اطمئنان · itminane — للمدارس العربية والإنجليزية",
      h1a: "يلمسون،",
      h1b: "فتطمئنّ.",
      sub: "اطمئنان نظام حضور مدرسي يرسل لولي الأمر رسالة واتساب لحظة مرور الطفل بوابة المدرسة. لا كشف حضور، ولا مجهود على المعلم. فقط طمأنينة.",
      ctaQuote: "اطلب عرض سعر لمدرستك",
      ctaWhats: "اطلب عبر واتساب",
      b1: "إشعار واتساب فوري",
      b2: "بدون أي مجهود للمعلم",
      b3: "طرفية تتحمل الطقس",
      floatTitle: "اطمئنان",
      floatMsg: "وصلت سارة إلى المدرسة · البوابة أ، ٨:٠٢ ص",
      floatTime: "الآن",
      imgAlt: "طرفية حضور اطمئنان البيضاء مثبتة على الجدار",
    },
    marquee: [
      "اطمئنان",
      "طمأنينة",
      "لمسة وتمضي",
      "بلا كشف حضور",
      "واتساب فوري",
      "لكل أبٍ وأمٍّ، كل يوم",
    ],
    bento: {
      kicker: "لمن هذا؟",
      title: "ثلاثة مكاسب كل صباح.",
      parents: {
        tag: "للأهل",
        title: "البوابة تقول صباح الخير.",
        body: "تصل رسالة واتساب لحظة لمس طفلك البطاقة — عند الوصول والانصراف، كل يوم. بلا سؤال ولا انتظار.",
        imgAlt: "بطاقة اطمئنان أمام حلقة القارئ المضيئة على الطرفية",
      },
      teachers: {
        tag: "للمعلمين",
        title: "كشف الحضور؟ أُلغي.",
        body: "لا قوائم، ولا عدّ، ولا أوراق. البوابة تسجّل الحضور بنفسها بينما يبدأ الدرس في وقته.",
      },
      admin: {
        tag: "للمدرسة",
        title: "كل وصول مسجّل.",
        body: "سجلات يومية تلقائية وأمان على مستوى البوابة وتقارير حضور واضحة — جاهزة وقت حاجتك إليها.",
      },
    },
    sim: {
      kicker: "تجربة حية",
      title: "جرّب بوابة الصباح",
      sub: "المس البطاقة وشاهد ماذا يصل لولي الأمر — في أقل من ثانية.",
      arrival: "وصول الصباح",
      departure: "وقت الانصراف",
      tapBtn: "المس البطاقة",
      tapAgain: "المس مرة أخرى",
      tapping: "جارٍ القراءة…",
      terminal: "طرفية اطمئنان",
      screenIdle: "جاهزة للمس",
      screenRead: "تقرأ البطاقة…",
      screenDone: "تم التسجيل",
      hint: "هذه محاكاة — الإشعار الحقيقي يصل إلى واتساب ولي الأمر.",
      notif: {
        chat: "اطمئنان",
        online: "متصل",
        arrive: "سارة أحمد وصلت إلى المدرسة",
        depart: "سارة أحمد انصرفت من المدرسة",
        meta: "البوابة أ",
        timeA: "٨:٠٢ ص",
        timeD: "٢:٣٠ م",
      },
      empty: "إشعار ولي الأمر سيظهر هنا",
    },
    how: {
      kicker: "كيف يعمل",
      title: "ثلاث خطوات. بلا مجهود.",
      steps: [
        {
          n: "٠١",
          t: "لمسة وتمضي",
          b: "يلمس الطفل بطاقته على الطرفية عند البوابة، وتتم القراءة في جزء من الثانية — بلا طوابير ولا كاميرا ولا بصمة.",
        },
        {
          n: "٠٢",
          t: "إرسال آمن",
          b: "ترسل الطرفية حدث حضور مشفّرًا إلى سحابة اطمئنان عبر واي فاي المدرسة أو شريحة 4G.",
        },
        {
          n: "٠٣",
          t: "يصل واتساب",
          b: "يستلم الأهل الإشعار فورًا مع اسم الطفل والبوابة والوقت. والمعلم لا يفعل شيئًا إطلاقًا.",
        },
      ],
      note: "مجهود المعلم المطلوب: صفر.",
    },
    hw: {
      kicker: "العتاد",
      title: "متين عند البوابة. بسيط بين الأيدي.",
      sub: "قطعتان فقط — طرفية عند كل مدخل وبطاقة لكل طالب. هذا كامل النظام.",
      terminal: {
        name: "طرفية اطمئنان",
        sub: "تُثبّت عند كل بوابة",
        feats: [
          "تثبيت على الحائط أو البوابة",
          "تعمل عبر واي فاي المدرسة أو شريحة 4G",
          "بطارية احتياطية عند انقطاع الكهرباء",
          "نغمة تأكيد مسموعة",
          "هيكل مقاوم للطقس",
        ],
      },
      card: {
        name: "بطاقة اطمئنان",
        sub: "واحدة لكل طالب، بحزام معلّق",
        feats: [
          "بطاقة متينة بحزام للطالب",
          "مطبوعة بهوية مدرستك",
          "يُعاد إصدارها فورًا عند الفقدان",
          "لمسة واحدة — بلا كاميرا ولا بصمة",
        ],
        imgAlt: "ثلاث بطاقات اطمئنان على أشرطة بنفسجية وبرتقالية",
      },
      note: "تُعتمد المواصفات النهائية مع عرض السعر.",
    },
    ai: {
      badge: "قريبًا",
      kicker: "اطمئنان Pulse",
      title: "قريبًا: ذكاء اصطناعي يساعدك على فهم طفلك.",
      body: "سيقرأ Pulse أنماط الحضور ويسلّط الضوء بلطف على ما يهم — طفل تأخر ثلاثة صباحات متتالية، وملخص أسبوعي للأهل، ورؤى تساعد المدرسة على الاهتمام مبكرًا.",
      chips: ["أنماط الحضور", "تنبيهات لطيفة للتغيّرات", "ملخص أسبوعي للأهل"],
    },
    quote: {
      kicker: "لنبدأ",
      title: "اطلب عرض سعر",
      sub: "أخبرنا عن مدرستك وسنرد عليك عبر واتساب بعرض مخصص — يشمل الأجهزة والبطاقات والتركيب.",
      name: "الاسم الكامل",
      school: "اسم المدرسة",
      city: "المدينة / الدولة",
      students: "عدد الطلاب",
      phone: "رقم واتساب",
      role: "صفك",
      message: "شيء إضافي؟ (اختياري)",
      msgPlaceholder: "عدد البوابات، أسئلة، جداول زمنية…",
      namePh: "مثال: أمين خليل",
      schoolPh: "مثال: مدرسة النور الدولية",
      cityPh: "مثال: دبي، الإمارات",
      roles: {
        principal: "مدير / إدارة",
        it: "منسق تقنية",
        teacher: "معلم",
        parent: "ولي أمر",
        other: "أخرى",
      },
      submit: "إرسال الطلب",
      sending: "جارٍ الإرسال…",
      successTitle: "وصلنا طلبك.",
      successBody: "سنراسلك على واتساب قريبًا — عادة في نفس اليوم.",
      successAgain: "إرسال طلب آخر",
      err: "حدث خطأ — تأكد من الحقول وحاول مرة أخرى.",
      waTitle: "تفضل المحادثة؟",
      waBody: "راسلنا مباشرة وسنكمل طلبك داخل واتساب.",
      waBtn: "اطلب عبر واتساب",
      contact: "تواصل معنا",
      rights: "جميع الحقوق محفوظة.",
    },
    faq: {
      kicker: "الأسئلة",
      title: "أسئلة وجوابها بصراحة",
      items: [
        {
          q: "هل نحتاج إنترنت سريعًا عند البوابة؟",
          a: "لا. تعمل الطرفية عبر واي فاي المدرسة أو شريحة 4G — أيهما متاح. وإشعارات الحضور صغيرة جدًا فتكفي أبسط الشبكات.",
        },
        {
          q: "من يقوم بالتركيب؟",
          a: "نرسل الطرفية جاهزة للتثبيت. أغلب المدارس تعلّقها عند البوابة وتشغّلها — ونرشد فريقكم خطوة بخطوة في مكالمة قصيرة لربط البطاقات.",
        },
        {
          q: "وإذا فقد الطفل بطاقته؟",
          a: "البطاقات غير مكلفة ويُعاد إصدارها فورًا. عطّل البطاقة المفقودة من لوحة التحكم وامسح الجديدة مرة واحدة — وانتهى الأمر.",
        },
        {
          q: "هل يستلم الأبوان الإشعارات؟",
          a: "نعم. الأب أو الأم أو ولي الأمر — يمكن ربط أي رقم واتساب بنفس الطفل، ويصل الجميع التنبيه نفسه.",
        },
        {
          q: "وهل بيانات أطفالنا خاصة؟",
          a: "يحفظ النظام ما يحتاجه فقط: معرّف البطاقة واسمًا ورقم ولي أمر. سجلات الحضور ملك للمدرسة ولا تُباع أو تُشارك أبدًا.",
        },
      ],
    },
    gallery: {
      kicker: "معرض الصور",
      title: "من داخل النظام",
      sub: "الطرفية والبطاقة ولحظة وصول الخبر.",
      captions: [
        "عند البوابة، جاهزة كل صباح",
        "بطاقة لكل طالب",
        "صباحًا باكرًا وبعد العصر",
        "الرسالة التي تهم",
      ],
    },
    footer: {
      story: "اطمئنان — تلك الطمأنينة التي تشعر بها عندما تعلم أنهم وصلوا بأمان.",
      product: "المنتج",
      company: "الشركة",
      contact: "تواصل",
      admin: "الإدارة",
      rights: "جميع الحقوق محفوظة.",
      bilingual: "English · العربية",
    },
    admin: {
      loginTitle: "تسجيل دخول الإدارة",
      loginSub: "لوحة طلبات عروض الأسعار",
      email: "البريد الإلكتروني",
      password: "كلمة المرور",
      signIn: "دخول",
      signingIn: "جارٍ الدخول…",
      back: "العودة للموقع",
      dashTitle: "طلبات عروض الأسعار",
      new: "جديد",
      total: "طلب",
      loading: "جارٍ التحميل…",
      empty: "لا طلبات بعد — ستظهر هنا فور إرسال أي مدرسة النموذج.",
      error: "تعذر تحميل الطلبات. حاول التحديث.",
      signOut: "خروج",
      viewSite: "عرض الموقع",
      msgLabel: "رسالة",
      retry: "إعادة المحاولة",
    },
  },
};
